import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { webSocketApiUrlsDictionary } from '../../../constants';

const MonitoringPage = () => {
  const history = useHistory();
  const theme = localStorage.getItem('theme');
  const monitoring_url =
    webSocketApiUrlsDictionary[theme]?.monitoringUrl ||
    process.env.REACT_APP_MONITORING_URL;
  const token = localStorage.getItem('auth-token');
  const tenant_id = localStorage.getItem('api-key');

  useEffect(() => {
    window.open(
      `${monitoring_url}?token=${token}&tenant_id=${tenant_id}`,
      '_blank',
      'noopener,noreferrer',
    );
    history.goBack();
  }, []);

  return <></>;
};

export default MonitoringPage;
